// src/helper/axiosInstance.js
import axios from "axios";
import Cookies from "js-cookie";
// import { toast } from "react-hot-toast"; // Uncomment if you want visual feedback

// Define your BASE_URL here
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// 1. REQUEST INTERCEPTOR: Automatically adds the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["Accept"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 2. RESPONSE INTERCEPTOR: Handles 401 errors and refreshing
axiosInstance.interceptors.response.use(
  (response) => response, // Return successful responses directly
  async (error) => {
    const originalRequest = error.config;

    // Check if error is 401 (Unauthorized) and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        console.log("Token expired. Refreshing...");
        const refreshToken = Cookies.get("refresh_token");

        if (!refreshToken) throw new Error("No refresh token");

        // 🟢 CHANGED: Using a normal JSON object instead of FormData
        const payload = {
          refresh_token: refreshToken,
         
        };

        // Call API directly (using raw axios to avoid loop)
        const refreshResponse = await axios.post(
          `${BASE_URL}/auth/refresh`,
          payload, 
          {
            headers: { 
              "Content-Type": "application/json" // Standard JSON header
            },
          }
        );

        console.log("Token refreshed successfully", refreshResponse.data);

        const newAccessToken = refreshResponse.data.access_token;
        const newRefreshToken = refreshResponse.data.refresh_token;

        // Update Cookies
        Cookies.set("access_token", newAccessToken);
        
        if (newRefreshToken) {
          Cookies.set("refresh_token", newRefreshToken);
        }

        // Update headers for the failed request with the NEW token
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        
        // Update the default header for future requests
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;

        // Retry the original request
        return axiosInstance(originalRequest);

      } catch (refreshError) {
        // If refresh fails, logout user
        console.error("Refresh failed:", refreshError);
        
        // Clear all auth cookies/storage
        Cookies.remove("access_token");
        Cookies.remove("refresh_token");
        Cookies.remove("sid");
        Cookies.remove("userid");
        localStorage.clear();
        
        // Redirect to login
        window.location.href = "/"; 
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;